<script>
export default {
    name: 'IconRdv'
}
</script>
<template>
    <svg
        class="base-icon icon-rdv"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M27 8v4h10V8h6v4h13v44H8V12h13V8h6zm12.252 24L28.997 42.383l-4.249-4.3L22 40.864 28.944 48 42 34.782 39.252 32zM21 17h-8v8h38v-8h-8v3h-6v-3H27v3h-6v-3z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
